<template>
  <div class="challenge" :view="currentView" :initial="!simulation.started" :number="challenge && challenge.number" :stopped="!simulation.running" ref="challenge" :finished="pump && challengeEnded">
    <Background :pump="pump" ></Background>
    <Tutorial v-if="pump && !challengeEnded && tutorialRef" :challenge="challenge && challenge.number" :view="currentView" :reference="tutorialRef" ref="tutorial" id="tutorial" @exit="exitTutorial(false)" @change="updateRef($event)"></Tutorial>
    <button id="exit-button" v-if="currentView=='messages' && simulation.data.currentTime==0 && challenge && challenge.number<=1 && !challengeEnded" class="action-button action-squared" @click="exitChallenge()">Exit</button>
    <div class="timebar-container" :loaded="loaded">
      <Timebar v-if="simulation.started || (challenge && challenge.number>1)" :pump="pump" :challenge="challenge" ref="timebar" @exit="exitChallenge()"></Timebar>
    </div>
    <div class="tablet-container" :loaded="loaded">
      <div class="tablet" ref="tablet" id="tablet" :starting="starting">
        <div class="screen">
          <Messages  v-show="currentView=='messages'" :pump="pump" ref="msg" :active="currentView=='messages'" @action="messageAction($event)"></Messages>
          <Pumpcontrol v-if="currentView=='pumpcontrol'" @pumpFailed="pumpFailed($event)" @updatetime="pump=$refs.pump" ref="pump" :challenge="challenge"></Pumpcontrol>
        </div>
      </div>
    </div>
    <button id="exit-tutorial" v-if="challenge && challenge.number==0 && currentView=='pumpcontrol' && !challengeEnded" class="action-button" @click="exitTutorial(false)">Skip Tutorial</button>
    <Endchallenge v-if="challenge && challengeEnded" @restart="restartChallenge($event)" @next="nextChallenge($event)" @exit="exitChallenge(true)"></Endchallenge>
    <Alert ref="alert"></Alert>
    <Unlock @unlockchallenge="unlockChallenge($event)" ref="unlock"></Unlock>
  </div>
</template>

<script>
import Messages from '@/views/Messages.vue'
import Pumpcontrol from '@/views/PumpControl.vue'
import Timebar from '@/components/Timebar.vue'
import Tutorial from '@/components/Tutorial.vue'
import Background from '@/components/Background.vue'
import Alert from '@/components/Alert.vue'
import Unlock from '@/components/Unlock.vue'
import Endchallenge from '@/views/Endchallenge.vue'

import simulation from '@/lib/simulation.js'
import messages from '@/lib/messages.js'
import challenges from '@/assets/json/challenges.json'

export default {
  name: 'challenge',
  data: function () {
    return {
      state: {},
      tutorialRef: null,
      pump: null,
      challenges: challenges,
      currentView: null,
      challenge: null,
      currentTime: 0,
      simulation: simulation,
      alertVisible: false,
      alertTitle: '',
      alertContent: '',
      loaded: 0,
      challengeStarted: 0,
      analyticsSaveMessage: false,
      analyticsMissedMessage: false,
      starting: 0
    }
  },
  props: {
    number: String,
    view: String
  },
  mounted: function () {
    const self = this
    self.setupChallenge(this.number)
    simulation.started = false
    const num = Number(this.number)
    if (isNaN(num) || num > 3) {
      this.$router.replace('/')
    }
    if (window.blurFunc) {
      window.removeEventListener('blur', window.blurFunc)
    }
    window.blurFunc = function () {
      if (simulation.data.tutorialId) {
        return
      }
      if (simulation.running) {
        simulation.stopMonitor()
        if (!self.$refs.alert) {
          return
        }
        self.$refs.alert.show('Game Paused', 'Your game is currently paused, when you are ready you can resume playing or exit to the main menu', function (btn) {
          if (btn === null) {
            simulation.startMonitor()
          }
          if (btn === 'Resume') {
            simulation.startMonitor()
          }
          if (btn === 'Exit') {
            self.exitToHome()
          }
        }, ['Resume', 'Exit'])
      }
    }
    window.addEventListener('blur', window.blurFunc)
    this.currentView = this.view || 'messages'
    self.showTutorial()
    window.sim = simulation
    window.ch = this
    setTimeout(function () {
      self.loaded = 1
    }, 100)
  },
  methods: {
    updateRef: function (ref) {
      this.tutorialRef = ref
    },
    messageAction: function (cfg) {
      if (cfg.action === 'skipTutorial') {
        this.exitTutorial(false)
      }
      if (cfg.action === 'start') {
        this.startChallenge(cfg.challenge, true)
        if (cfg.analytics) {
          setTimeout(function () {
            for (const idx in cfg.analytics) {
              simulation.doAnalytics(simulation.data.pumps[cfg.analytics[idx]])
              if (simulation.data.pumps[cfg.analytics[idx]].gpm <= simulation.params.GPM_HIGH_DAMAGE) {
                simulation.data.pumps[cfg.analytics[idx]].preventFail = true
              }
            }
          }, 500)
        }
      }
    },
    setupChallenge: function (number) {
      simulation.challengeNumber = number * 1
      simulation.reset()
      messages.currentChallenge = number
      messages.reset()
      this.analyticsSaveMessage = false
      this.analyticsMissedMessage = false
      this.challenge = this.challenges[number * 1]
      this.showTutorial()
      this.$forceUpdate()
    },
    unlockChallenge: function (number) {
      this.startChallenge(number, false, true)
    },
    exitTutorial: function (goToMessages) {
      const self = this
      this.$refs.alert.show('Skip Tutorial?', 'You can revisit the tutorial at any time by going to your Messages section and coming back to your Supervisors message', function (btn) {
        if (btn === 'Skip') {
          self.startChallenge(1, true, goToMessages)
        }
      }, ['Skip'])
    },
    startChallenge: function (chNumber, firstRead, showMessageTab) {
      const self = this
      self.starting = true
      simulation.clear()
      this.tutorialRef = null
      self.setupChallenge(chNumber)
      self.$router.push('/challenge/' + chNumber)
      if (!this.$store.state.popups.analyticsChallenge && chNumber > 1) {
        this.$store.state.popups.analyticsChallenge = chNumber
        this.$store.dispatch('store')
      }
      if (chNumber > 1 && this.$store.state.popups.analyticsChallenge !== chNumber) {
        this.$store.state.popups.analyticsChallenge = -1
        this.$store.dispatch('store')
      }
      this.$nextTick(function () {
        if (firstRead) {
          messages.list[0].read = true
        }
        self.showTutorial()
        self.starting = false
        if (showMessageTab) {
          self.$router.push('/challenge/' + chNumber + '/messages')
        } else {
          self.tutorialRef = null
          self.$router.push('/challenge/' + chNumber + '/pumpcontrol')
          self.$nextTick(function () {
            if (firstRead) {
              messages.list[0].read = true
            }
          })
        }
      })
    },
    restartChallenge: function (chNumber) {
      simulation.clear()
      this.$nextTick(function () {
        this.startChallenge(chNumber, false, true)
        simulation.started = false
      })
    },
    nextChallenge: function (chNumber) {
      const self = this
      if (this.$store.state.locks[chNumber]) {
        this.$refs.unlock.showContactForm(chNumber, false)
        return
      }
      this.$refs.alert.show('Next Level', 'Are you ready for the next Challenge?', function (btn) {
        if (btn === 'Ok') {
          self.startChallenge(chNumber, false, true)
        }
      }, ['Ok', 'Cancel'])
    },
    showTutorial: function () {
      if (this.challenge.tutorialId && this.tutorialRef !== 0) {
        const self = this
        this.$nextTick(function () {
          self.tutorialRef = self.challenge.tutorialId
        })
      } else {
        this.tutorialRef = null
      }
    },
    pumpFailed: function (pump) {
      if (this.challenge.number >= 1 && !pump.analytics) {
        if (!this.$store.state.popups.firstFail) {
          this.tutorialRef = 'stop-fail-' + pump.number
          this.$store.state.popups.firstFail = true
          this.$store.dispatch('store')
        }
      } else if (this.challenge.number > 1) {
        if (pump.analytics) {
          if (this.$store.state.popups.analyticsChallenge === this.challenge.number && !this.analyticsSaveMessage) {
            this.tutorialRef = 'analytics-save-' + pump.number
            this.analyticsSaveMessage = true
          }
        } else {
          if (!this.$store.state.popups.analyticsChallenge === this.challenge.number && !this.analyticsMissedMessage) {
            this.tutorialRef = 'analytics-miss-' + pump.number
            this.analyticsMissedMessage = true
          }
        }
      }
    },
    exitChallenge: function (skipConfirm) {
      const self = this
      if (simulation.running) {
        simulation.stopMonitor()
      }
      if (skipConfirm) {
        self.exitToHome()
      }
      self.$refs.alert.show('Exit Game', 'Are you sure you want to exit this challenge? All progress will be lost if you exit the challenge', function (btn) {
        if (btn === 'Resume') {
          if (!simulation.data.tutorialId && simulation.monitorCallback) {
            simulation.startMonitor()
          }
        }
        if (btn === 'Exit') {
          self.exitToHome()
        }
      }, ['Exit', 'Resume'])
    },
    exitToHome: function () {
      this.tutorialRef = null
      simulation.data.tutorialId = null
      simulation.startMonitor()
      simulation.clear()
      this.$router.push('/')
    }
  },
  computed: {
    challengeEnded: function () {
      return simulation.data.currentTime === simulation.params.END_TIME || simulation.data.challengeFailed
    }
  },
  components: {
    Messages,
    Pumpcontrol,
    Background,
    Tutorial,
    Timebar,
    Alert,
    Unlock,
    Endchallenge
  },
  watch: {
    number: function (newValue) {
      this.setupChallenge(newValue)
      this.tutorialRef = null
      const self = this
      this.$nextTick(function () {
        self.tutorialRef = self.challenge.tutorialId
      })
    },
    view: function (newValue) {
      this.tutorialRef = simulation.data.tutorialId
      this.currentView = this.view || 'messages'
      if (this.currentView === 'messages') {
        simulation.stopMonitor()
      } else {
        if (simulation.data.currentTime === 0 && newValue === 'pumpcontrol') {
          const self = this
          if (self.challenge.number !== this.number) {
            this.setupChallenge(this.number)
          }
          this.tutorialRef = null
          this.$nextTick(function () {
            self.tutorialRef = self.challenge.tutorialId
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss" >
.challenge{
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  background-color:#000;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  overflow: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.timebar-container{
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  top: 5.5vh;
  z-index: 1;
  &[loaded='0']{
    margin-top: -20vh;
    opacity: 0;
    transition: margin-top ease-in-out .5s, opacity linear .5s;
  }
  &[loaded='1']{
    margin-top: 0;
    opacity: 1;
    transition: margin-top ease-in-out .5s, opacity linear .5s;
  }
}
.tablet-container{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  margin: 0 auto;
  max-width: 1600px;
  &[loaded='0']{
    margin-top: 100vh;
    opacity: 0;
    transition: margin-top ease-in-out .5s, opacity linear .5s;
  }
  &[loaded='1']{
    margin-top: 0;
    opacity: 1;
    transition: margin-top ease-in-out .5s, opacity linear .5s;
  }
}
.tablet{
  position: relative;
  top: 6vh;
  width: 932px;
  height: 700px;
  margin: 0 auto;
  border-radius: 20px;
  border: 4px solid #313131;
  background-color: #000;
  padding: 50px 58px 50px 58px;
  transition: margin-right ease-in-out .5s;
  margin-right: auto;
  transform-origin: 50% 50%;
  .screen{
      background-color: #313131;
      border: 1px solid #313131;
      width: 100%;
      height: 100%;
      overflow: hidden;
      > div{
        height: 100%;
      }
  }
  &::after{
    content: ' ';
    width: 34px;
    height: 34px;
    position: absolute;
    right: 12px;
    top: 48%;
    border-radius: 99% 99%;
    border: 1px solid #313131;
  }
  &::before{
    content: ' ';
    width: 12px;
    height: 12px;
    position: absolute;
    left: 23px;
    top: 49%;
    border-radius: 99% 99%;
    background-color: #313131;
  }
}
.challenge[view="messages"]{
  .tablet{
    margin-right: 0;
  }
  &::v-deep{
    .tutorial{
      display:none;
    }
  }
}
.challenge[view="messages"][number="0"][initial="true"]{
  .tablet{
    margin-right: auto;
  }
}
.challenge{
  .tablet[starting='true']{
    margin-right: 20%;
  }
}
.challenge[view="messages"][running='true']{
  .tablet{
    margin-right: 0;
  }
}
.challenge[view="pumpcontrol"]{
  .tablet{
    margin-right: 0;
  }
}
.challenge[finished='true']{
  .timebar-container{
    opacity: 0;
    pointer-events: none;
    transition: opacity linear .5s;
  }
  .tablet{
    opacity: 0;
    transition: opacity linear .5s;
  }
  &::v-deep .chat-baloon{
    display:none;
  }
  .layer.background{
    filter: blur(2px)
  }
  .endchallenge{
    display: flex;
  }
}
#exit-button{
    position: absolute;
    right: 8vw;
    top: 4vw;
    z-index: 1;
}
#exit-tutorial{
    position: absolute;
    right: 8vw;
    bottom: 2vw;
    z-index: 1;
}
@media (max-height: 1040px){
  .challenge[number="0"]:not([initial="true"]) .tablet{
    height: 640px;
    top: 4vh;
  }
}
@media (max-height: 880px){
  .challenge[number="0"]:not([initial="true"]) .tablet{
    height: 610px;
  }
  .tablet{
    width: 845px;
    height: 624px;
    padding: 44px 46px 44px 46px;
    border: 3px solid #313131;
    &::after{
      width: 30px;
      height: 30px;
      right: 8px;
      top: 48%;
    }
    &::before{
      left: 17px;
    }
  }
  #exit-tutorial{
    right: 5vw;
    bottom: 2vw;
  }
}
@media (max-height: 840px){
  .challenge[number="0"]:not([initial="true"]) .tablet{
    height: 520px;
  }
  .challenge[number="0"][initial="true"] .tablet{
    width: 780px;
    height: 560px;
  }
  .tablet{
    width: 750px;
    height: 540px;
    padding: 32px 40px 32px 40px;
    &::after{
      width: 27px;
      height: 27px;
      right: 6px;
      top: 48%;
    }
    &::before{
      left: 14px;
    }
  }
  #exit-button{
    top: 2vw;
    right: 4vw;
  }
}
@media (max-height: 700px){
  .challenge[number="0"]:not([initial="true"]) .tablet{
    height: 480px;
    top: 3vh;
  }
  .tablet{
    width: 710px;
    height: 480px;
    padding: 30px 38px 30px 32px;
    &::after{
      right: 6px;
      top: 48%;
    }
    &::before{
      left: 10px;
    }
  }
}
@media (max-height: 660px){
  .tablet, .challenge[number="0"]:not([initial="true"]) .tablet, .challenge[number="0"][initial="true"] .tablet{
    width: 680px;
    height: 480px;
    padding: 26px 32px 26px 28px;
    &::after{
      right: 5px;
      top: 48%;
      width: 22px;
      height: 22px;
    }
  }
  #exit-tutorial{
    bottom: 1vw;
  }
}
@media (max-height: 600px){
  .tablet, .challenge[number="0"]:not([initial="true"]) .tablet, .challenge[number="0"][initial="true"] .tablet{
    width: 620px;
    height: 420px;
    padding: 20px 28px 20px 24px;
    &::after{
      right: 5px;
      top: 49%;
      width: 18px;
      height: 18px;
    }
    &::before{
      left: 6px;
    }
  }
}
</style>
